var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#3E7EEE",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10265_115227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9058 64.8756H37.5957C36.3155 64.8756 35.2778 63.8378 35.2778 62.5577V35.1187C35.2778 33.8386 36.3155 32.8008 37.5957 32.8008H58.9059C60.1861 32.8008 61.2238 33.8386 61.2238 35.1187V62.5576C61.2238 63.8378 60.186 64.8756 58.9058 64.8756Z",
    fill: "#F7F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9058 32.8008H56.5879C57.8681 32.8008 58.9058 33.8386 58.9058 35.1187V62.5576C58.9058 63.8378 57.868 64.8755 56.5879 64.8755H58.9058C60.1859 64.8755 61.2236 63.8377 61.2236 62.5576V35.1187C61.2237 33.8386 60.1859 32.8008 58.9058 32.8008V32.8008Z",
    fill: "#EDEBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8786 71.1996H34.918C33.6379 71.1996 32.6001 70.1618 32.6001 68.8817V49.0249C32.6001 47.7447 33.6379 46.707 34.918 46.707H46.2249C47.1467 46.707 47.9502 47.3344 48.1738 48.2286L48.5719 49.8212C48.7955 50.7155 49.5989 51.3428 50.5208 51.3428H60.8785C62.1587 51.3428 63.1964 52.3806 63.1964 53.6607V68.8816C63.1965 70.1618 62.1587 71.1996 60.8786 71.1996Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8789 51.3438H58.561C59.8412 51.3438 60.8789 52.3815 60.8789 53.6616V68.8826C60.8789 70.1628 59.8411 71.2005 58.561 71.2005H60.8789C62.1591 71.2005 63.1968 70.1627 63.1968 68.8826V53.6617C63.1969 52.3815 62.1591 51.3438 60.8789 51.3438Z",
    fill: "#999FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8561 48.2286L46.2542 49.8212C46.4778 50.7155 47.2813 51.3428 48.2031 51.3428H50.521C49.5991 51.3428 48.7957 50.7154 48.5721 49.8212L48.174 48.2286C47.9504 47.3343 47.1469 46.707 46.2251 46.707H43.9072C44.8291 46.707 45.6325 47.3343 45.8561 48.2286Z",
    fill: "#999FA3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1544 36.8581H39.3724C39.0524 36.8581 38.793 36.5987 38.793 36.2787C38.793 35.9586 39.0524 35.6992 39.3724 35.6992H56.1544C56.4745 35.6992 56.7339 35.9586 56.7339 36.2787C56.7339 36.5987 56.4745 36.8581 56.1544 36.8581Z",
    fill: "#A198A4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6776 40.3347H39.3724C39.0524 40.3347 38.793 40.0753 38.793 39.7552C38.793 39.4352 39.0524 39.1758 39.3724 39.1758H52.6776C52.9977 39.1758 53.257 39.4352 53.257 39.7552C53.2571 40.0752 52.9977 40.3347 52.6776 40.3347Z",
    fill: "#A198A4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5186 43.8112H39.3724C39.0524 43.8112 38.793 43.5518 38.793 43.2318C38.793 42.9118 39.0524 42.6523 39.3724 42.6523H51.5186C51.8386 42.6523 52.098 42.9118 52.098 43.2318C52.098 43.5518 51.8387 43.8112 51.5186 43.8112Z",
    fill: "#A198A4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7163 57.2031L55.115 55.7012L58.2718 50.2337L60.8731 51.7356L57.7163 57.2031Z",
    fill: "#A198A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6707 66.4001C51.9167 67.1195 53.51 66.6926 54.2294 65.4465L58.8418 57.4577C59.1464 56.93 58.9656 56.2553 58.438 55.9506L55.8366 54.4488C55.3089 54.1441 54.6342 54.3249 54.3295 54.8526L49.7172 62.8414C48.9977 64.0874 49.4246 65.6807 50.6707 66.4001Z",
    fill: "#655E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4377 55.9507L55.8363 54.4488C55.3086 54.1441 54.6339 54.3249 54.3293 54.8526L54.3014 54.9008L56.1198 55.9506C56.6475 56.2553 56.8283 56.9301 56.5236 57.4577L51.9113 65.4465C51.6449 65.9079 51.2585 66.2567 50.8145 66.4768C52.0367 67.0852 53.5372 66.6451 54.2291 65.4465L58.8415 57.4577C59.1462 56.9301 58.9654 56.2553 58.4377 55.9507Z",
    fill: "#544F57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5679 53.1841C57.3459 53.8108 58.221 54.3218 59.1669 54.6901L60.8723 51.7362L58.2709 50.2344L56.5679 53.1841Z",
    fill: "#8B808E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3157 48.8015C72.131 44.6039 70.1998 39.7296 66.0022 37.9143C61.8046 36.099 56.9303 38.0302 55.115 42.2278C53.2997 46.4253 55.2309 51.2997 59.4285 53.115C63.626 54.9303 68.5004 52.9991 70.3157 48.8015Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7205 37.25C62.3272 37.25 61.9404 37.2782 61.5615 37.3315C65.5799 37.8969 68.6818 41.3574 68.6818 45.5293C68.6818 49.7012 65.5799 53.1616 61.5615 53.7271C61.9403 53.7804 62.3271 53.8086 62.7205 53.8086C67.2857 53.8086 70.9997 50.0945 70.9997 45.5293C70.9997 40.9641 67.2857 37.25 62.7205 37.25Z",
    fill: "#8BB3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9709 50.4923C66.716 49.8109 68.3891 47.0333 67.7077 44.2882C67.0264 41.5432 64.2488 39.8702 61.5037 40.5515C58.7585 41.2328 57.0855 44.0105 57.7668 46.7555C58.4482 49.5006 61.2258 51.1736 63.9709 50.4923Z",
    fill: "#E6ECF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7205 40.4102C62.3218 40.4102 61.9342 40.4575 61.5615 40.5441C63.8274 41.0708 65.5214 43.1051 65.5214 45.5291C65.5214 47.9529 63.8274 49.9872 61.5615 50.5139C61.9342 50.6006 62.3218 50.6479 62.7205 50.6479C65.543 50.6479 67.8393 48.3516 67.8393 45.5291C67.8393 42.7064 65.543 40.4102 62.7205 40.4102Z",
    fill: "#D7E1F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10265_115227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    fill: "white",
    transform: "translate(32.6001 32.8008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateFolders);
export default __webpack_public_path__ + "static/media/empty-state-folders.160bc2b51bf087ec389d91b2f5b6586b.svg";
export { ForwardRef as ReactComponent };